import React from "react";
import { CustomFieldSchemaFragment, Option } from "__generated__/graphql";
import { RadioGroup, RadioOption } from "common/radio";

interface ICustomListSelectFieldProps {
  value: Option | null;
  setValue: (value: Option | null) => void;
  schema?: CustomFieldSchemaFragment | null;
  showLabel?: boolean;
  labelledById?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}
export const CustomListSelectField = ({
  value,
  setValue,
  schema,
}: ICustomListSelectFieldProps) => {
  const options: RadioOption[] =
    schema?.optionChoices?.map((optionChoice) => ({
      label: optionChoice.value,
      value: optionChoice.id,
      "data-custom-css-value": optionChoice.value, // for form custom css
    })) || [];

  const handleChange = (selectedValue: string) => {
    const selectedOption = schema?.optionChoices?.find(
      (option) => option.id === selectedValue,
    );

    if (selectedOption) {
      setValue({
        colour: selectedOption.colour,
        value: selectedOption.value,
        id: selectedOption.id,
      });
    }
  };

  return (
    <RadioGroup
      label=""
      options={options}
      onChange={handleChange}
      value={value?.id || ""}
    />
  );
};
